
import rules from "../../mixins/rules.mixin.js";

export default {
  name: "MembersForm",

  mixins: [rules],

  data: () => ({
    member: {
      nome: "",
      nascimento: "",
      cpf: "",
      parentesco: "",
      plano_dental: false,
    },
    valid: false,
    dialog: false,
    kinship: [
      "Cônjuge",
      "Filho(a)",
      "Pai/Mãe",
      "Avô/Avó",
      "Irmão/Irmã",
      "Neto(a)",
      "Sobrinho(a)",
    ],
  }),

  computed: {
    members_length() {
      let adicionadosAnteriormente = this.adicionadosAnteriormente || 0;
      let naFilaParaApagar = this.naFilaParaApagar || 0;

      if (this.ownerIsMember) {
        return (
          this.members.length + adicionadosAnteriormente - naFilaParaApagar + 1
        );
      } else {
        return (
          this.members.length + adicionadosAnteriormente - naFilaParaApagar
        );
      }
    },

    members: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },

    ownerIsMember: {
      get() {
        return this.ownerIsMemberValue;
      },
      set(val) {
        this.$emit("ownerMemberChange", val);
      },
    },
    contratante_plano_dental: {
      get() {
        return this.contratante_plano_dental_value;
      },
      set(val) {
        this.$emit("contratante_plano_dental_change", val);
      },
    },
  },

  methods: {
    addMember() {
      if (this.$refs.AddMemberForm.validate()) {
        this.members.push({ ...this.member });
        this.dialog = false;
        this.member.nome = "";
        this.member.cpf = "";
        this.member.nascimento = "";
        this.member.parentesco = "";
      } else {
        alert("Existem campos vue precisam ser preenchidos.");
      }
    },
    removeMember(index) {
      this.members.splice(index, 1);
    },
  },

  mounted() {
    if (this.ownerNeedsToBeMember) {
      this.ownerIsMember = true;
    }
  },

  props: {
    members_limit: Number,
    value: Array,
    owner: Object,
    ownerNeedsToBeMember: Boolean,
    ownerIsMemberValue: Boolean,
    adicionadosAnteriormente: Number,
    naFilaParaApagar: Number,
    contratante_plano_dental_value: Boolean,
  },
};
